import api, { getSplitAbTreatment } from '../utils/api';
import { GET_USER } from '../constants/requests';
import { FINISH_SERVER_SIDE_RENDERING, LOGOUT, SET_IS_LAYOUT_HORIZONTAL } from '../constants/actions';
import { TreatmentTypes } from '../hooks/useGetSplitAb';

export function getUserRequest() {
  return {
    type: GET_USER.REQUEST,
  };
}

export function getUserReceive(response) {
  return {
    type: GET_USER.RECEIVE,
    response,
  };
}

export function getUserFailure(error) {
  return {
    type: GET_USER.FAILURE,
    error,
  };
}

export function getUser(pageWithSensitiveInformation = false, includeSummary = false) {
  return (dispatch) => {
    dispatch(getUserRequest());
    return dispatch(api.user.info({ pageWithSensitiveInformation, includeSummary }))
      .then((response) => {
        return dispatch(getUserReceive(response));
      })
      .catch((error) => {
        return dispatch(getUserFailure(error));
      });
  };
}

export function getIsLayoutHorizontal() {
  return (dispatch) => {
    return dispatch(getSplitAbTreatment({ featureName: 'zrm-left-nav' }))
      .then((response) => {
        const isLayoutHorizontal = response.data.response?.treatment === TreatmentTypes.ON;
        return dispatch(setIsLayoutHorizontal({ isLayoutHorizontal }));
      })
      .catch((_) => {
        return dispatch(setIsLayoutHorizontal({ isLayoutHorizontal: false }));
      });
  };
}

export function setIsLayoutHorizontal(response) {
  return {
    type: SET_IS_LAYOUT_HORIZONTAL,
    response,
  };
}

export function finishServerSideRendering() {
  return {
    type: FINISH_SERVER_SIDE_RENDERING,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}
